import { AllessehQuerySortKeyTypes, AllessehQuerySortOrderType } from 'hooks/useAllessehContentQuery';

enum SECTION_ENUM {
  LATEST = 'Latest'
}

const MAIN = {
  query: {
    or: [
      { terms: { key: 'Product', value: ['WSJ.com', 'WSJ Live Coverage'] } },
      { terms: { key: 'SectionType', value: ['stack'] } }
    ],
    not: [
      { terms: { key: 'Page', value: ['Mobile'] } },
      {
        terms: {
          key: 'SectionName',
          value: [
            'Corrections and Amplifications',
            'Decos and Corrections',
            'Direct Push Alert',
            'NewsPlus',
            'WSJ Puzzles'
          ]
        }
      },
      {
        terms: {
          key: 'SectionType',
          value: [
            'Deco Summary Liondoor',
            'Infogrfx House Of The Day',
            'Pepper & Salt',
            'Pro Bankruptcy Data Tables',
            'Whats News Business Finance',
            'Whats News World Wide',
            'Card',
            'featured_media',
            'featured_content'
          ]
        }
      }
    ]
  },
  count: 20,
  sort: [{ key: AllessehQuerySortKeyTypes.LiveDate, order: AllessehQuerySortOrderType.DESC }]
};

export { MAIN, SECTION_ENUM };
